var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "clipboard-type-icon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true",
      },
    },
    [
      _vm.type === "prompt"
        ? [
            _c("path", {
              attrs: {
                d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M20 3v4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M22 5h-4" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M4 17v2" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M5 18H3" } }),
          ]
        : _vm.type === "asin"
        ? [
            _c("line", { attrs: { x1: "4", x2: "20", y1: "9", y2: "9" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "4", x2: "20", y1: "15", y2: "15" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "10", x2: "8", y1: "3", y2: "21" } }),
            _vm._v(" "),
            _c("line", { attrs: { x1: "16", x2: "14", y1: "3", y2: "21" } }),
          ]
        : _vm.type === "gtin"
        ? [
            _c("path", { attrs: { d: "M3 5v14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M8 5v14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M12 5v14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M17 5v14" } }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M21 5v14" } }),
          ]
        : [
            _c("path", {
              attrs: {
                d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z",
              },
            }),
            _vm._v(" "),
            _c("path", { attrs: { d: "M15 3v4a2 2 0 0 0 2 2h4" } }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }